<template>
    <v-card class="mx-auto" outlined>
            <v-card-title>Dashboard</v-card-title>
            <v-container>
                <line-chart
                    v-if="loaded"
                    :chartdata="chartdata"
                    :options="options"/>
            </v-container>
            <v-container>
                <line
                    v-if="loaded"
                    :chart-options="options"
                    :chart-data="polarChart"
                    width="400"
                    height="400" />
            </v-container>
    </v-card>
</template>

<script>
import LineChart from './chart/Chart.vue'
import Line from './chart/Line.vue'
export default {
    name: 'dashboard',
    title: 'dashboard',

    components: { LineChart, Line },

    data: () => ({
    loaded: false,
    chartdata: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: 'Season',
          backgroundColor: '#A3BFA8',
          data: [40, 15,100, 40, 100, 150, 200, 150, 100, 40, 15, 40]
        },
        {
          label: 'Valuepass',
          backgroundColor: '#CDE7B0',
          data: [32, 30, 20, 10, 50, 90, 150, 40, 15, 40, 30, 20]
        },
        {
          label: 'Casual',
          backgroundColor: '#C8B8DB ',
          data: [10, 15, 50, 80, 40, 150, 200, 150, 100, 40, 15, 40]
        },
      ]
    },
    polarChart: {
      labels: [
          'Eating',
          'Drinking',
          'Sleeping',
          'Designing',
          'Coding',
          'Cycling',
          'Running'
        ],
        datasets: [
          {
            label: 'My First dataset',
            backgroundColor: 'rgba(179,181,198,0.2)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            data: [65, 59, 90, 81, 56, 55, 40]
          },
          {
            label: 'My Second dataset',
            backgroundColor: 'rgba(255,99,132,0.2)',
            pointBackgroundColor: 'rgba(255,99,132,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255,99,132,1)',
            data: [28, 48, 40, 19, 96, 27, 100]
          }
        ]
    },

    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
      //const { userlist } = await fetch('/api/userlist')
      //this.chartdata = userlist
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
    
}
</script>

<style lang="scss" scoped>
    .dashboard-card{
        flex: 1 0 21%; /* explanation below */
    }

    .doc-card-title{
        margin-left: -24px;
        padding: 2px 10px 2px 24px;
        background: #e0e0e0;
        color: #616161;
        position: relative;
        border-radius: 3px 5px 5px 0;
    }

    .slide-fade-enter-active {
  transition: all .9s ease;
}
.slide-fade-leave-active {
  transition: all .12s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}

.slide-fade-leave-to{
	transform: translateX(50px);
  	opacity: 0;
}

.grow { transition: all .2s ease-in-out; }
.grow:hover { transform: scale(1.05); }

.user-select-none{
    user-select: none;
}
</style>